import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";

export default function TeamIconGradient({
  style = {},
  width = 28,
  height = 28,
}) {
  return (
    <TouchableOpacity style={style}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M5.25 8.3125C6.94137 8.3125 8.3125 6.94137 8.3125 5.25C8.3125 3.55863 6.94137 2.1875 5.25 2.1875C3.55863 2.1875 2.1875 3.55863 2.1875 5.25C2.1875 6.94137 3.55863 8.3125 5.25 8.3125Z"
          fill="url(#paint0_linear)"
        />
        <Path
          d="M7.4375 19.6875V14C7.4375 12.6993 7.95813 11.5194 8.79988 10.6527C8.29369 10.2834 7.67287 10.0625 7 10.0625H3.5C1.81125 10.0625 0.4375 11.4362 0.4375 13.125V16.625C0.4375 16.7908 0.531125 16.9422 0.679437 17.0166L2.20631 17.78L2.62587 23.6565C2.6425 23.8853 2.83325 24.0625 3.0625 24.0625H7.4375C7.66675 24.0625 7.8575 23.8853 7.87412 23.6561L8.07713 20.8132C7.69037 20.5809 7.4375 20.1582 7.4375 19.6875Z"
          fill="url(#paint1_linear)"
        />
        <Path
          d="M22.75 8.3125C24.4414 8.3125 25.8125 6.94137 25.8125 5.25C25.8125 3.55863 24.4414 2.1875 22.75 2.1875C21.0586 2.1875 19.6875 3.55863 19.6875 5.25C19.6875 6.94137 21.0586 8.3125 22.75 8.3125Z"
          fill="url(#paint2_linear)"
        />
        <Path
          d="M20.5626 19.6875V14C20.5626 12.6993 20.0419 11.5194 19.2002 10.6527C19.7064 10.2834 20.3272 10.0625 21.0001 10.0625H24.5001C26.1888 10.0625 27.5626 11.4362 27.5626 13.125V16.625C27.5626 16.7908 27.4689 16.9422 27.3206 17.0166L25.7938 17.78L25.3742 23.6565C25.3576 23.8853 25.1668 24.0625 24.9376 24.0625H20.5626C20.3333 24.0625 20.1426 23.8853 20.1259 23.6561L19.9229 20.8132C20.3097 20.5809 20.5626 20.1582 20.5626 19.6875Z"
          fill="url(#paint3_linear)"
        />
        <Path
          d="M15.75 10.0625H12.25C10.0791 10.0625 8.3125 11.8291 8.3125 14V19.6875C8.3125 19.8962 8.4595 20.0756 8.66425 20.1162L10.5219 20.4877L10.9384 27.1521C10.9528 27.3827 11.144 27.5625 11.375 27.5625H16.625C16.856 27.5625 17.0472 27.3827 17.0616 27.1521L17.4781 20.4881L19.3357 20.1167C19.5405 20.0756 19.6875 19.8962 19.6875 19.6875V14C19.6875 11.8291 17.9209 10.0625 15.75 10.0625Z"
          fill="url(#paint4_linear)"
        />
        <Path
          d="M14 8.3125C16.1709 8.3125 17.9375 6.54588 17.9375 4.375C17.9375 2.20413 16.1709 0.4375 14 0.4375C11.8291 0.4375 10.0625 2.20413 10.0625 4.375C10.0625 6.54588 11.8291 8.3125 14 8.3125Z"
          fill="url(#paint5_linear)"
        />
        <Defs>
          <LinearGradient
            id="paint0_linear"
            x1="2.1875"
            y1="3.51581"
            x2="5.13592"
            y2="9.54034"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
          <LinearGradient
            id="paint1_linear"
            x1="0.4375"
            y1="13.0986"
            x2="8.80511"
            y2="23.3113"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
          <LinearGradient
            id="paint2_linear"
            x1="19.6875"
            y1="3.51581"
            x2="22.6359"
            y2="9.54034"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
          <LinearGradient
            id="paint3_linear"
            x1="19.2002"
            y1="13.0986"
            x2="27.5678"
            y2="23.3113"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
          <LinearGradient
            id="paint4_linear"
            x1="8.3125"
            y1="13.8577"
            x2="18.5647"
            y2="27.4742"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
          <LinearGradient
            id="paint5_linear"
            x1="10.0625"
            y1="2.14533"
            x2="13.8533"
            y2="9.89115"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
